<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">SMS/Email Templates</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-input placeholder="Search..." type="search" v-model="searchTerm" @input="customSearch(searchTerm)"></b-input>
          </div>
          <div class="level-item">
            <a title="Add" class="button is-small is-link" v-on:click="addTemplate()">
              <b-icon icon="plus" size="is-small" style="margin-left: 10px"></b-icon>
              <span> Add Templates </span>
            </a>
          </div>
        </div>
      </div>
      Total Records :
      <b>{{ total }}</b>
    </section>
    <section class="section is-main-section">
      <card-component class="has-table has-mobile-sort-spaced">
        <b-table :paginated="paginated" :per-page="10" :hoverable="true" default-sort="updatedAt" default-sort-direction="DESC" :data="searchFilterArray">
          <template slot-scope="props">
            <b-table-column label="Template Name" field="templateName" sortable> {{ props.row.templateName }} </b-table-column>
            <b-table-column label="Sender Key" field="templateSenderKey" sortable> {{ props.row.templateSenderKey }}</b-table-column>
            <b-table-column class="center" label="Sender Name" field="templateSenderName" sortable>
              {{ props.row.templateSenderName ? props.row.templateSenderName : '--' }}
            </b-table-column>
            <b-table-column label="Template Type" field="templateType" sortable> {{ props.row.templateType }} </b-table-column>
            <b-table-column label="Page Type" field="templatePageType" sortable> {{ props.row.templatePageType }} </b-table-column>
            <b-table-column label="UserType" field="templateUserType" sortable> {{ props.row.templateUserType }} </b-table-column>
            <b-table-column label="Status" field="isActive" sortable> {{ props.row.isActive ? 'Active' : 'Deactive' }} </b-table-column>
            <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered>
              <div class="buttons">
                <router-link :to="{ name: 'EditTemplate', params: { templateId: props.row.id } }" class="button is-info is-small btnicon" title="Edit" v-if="!props.row.deletedAt">
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
                <span class="button is-warning is-small btnicon" @click="showPopup(props.row.templateContent)" title="Preview">
                  <b-icon icon="eye" size="is-small" />
                </span>
                <button class="button is-small is-danger" type="button" v-if="!props.row.deletedAt" @click.prevent="deleteTemplate(props.row.id)" title="Delete">
                  <b-icon icon="trash-can" size="is-small" />
                </button>
                <button class="button is-small is-success" type="button" @click.prevent="restoreTemplate(props.row.id)" v-if="props.row.deletedAt" title="Restore">
                  <b-icon icon="restore" size="is-small" />
                </button>
              </div>
            </b-table-column>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>

    <div class="modal" :class="{ 'is-active': PreviewPopup }">
      <div class="modal-background"></div>
      <form class="modal-card is-small" style="width:50rem">
        <header class="modal-card-head">
          <p class="modal-card-title">
            <strong> Template content </strong>
          </p>
          <button class="delete" type="button" @click="PreviewPopup = false"></button>
        </header>
        <section class="modal-card-body">
          <div v-html="templateMsg"></div>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import _ from 'lodash'

export default {
  name: 'ListTemplate',
  components: {
    CardComponent
  },
  props: {
    checkable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      searchTerm: '',
      templateId: '',
      searchFilterArray: [],
      data: [],
      PreviewPopup: false,
      total: 0,
      isLoading: false,
      paginated: true,
      templateMsg: '',
      checkedRows: [],
      content: '',
      models: [],
      tempTemplate: [],
      loadingComponent: null
    }
  },

  async created () {
    this.loadingComponent = this.$buefy.loading.open()
    await this.getTemplate()
    this.loadingComponent.close()
  },
  methods: {
    customSearch: function (value) {
      if (_.isEmpty(value)) {
        this.searchFilterArray = this.tempTemplate
      } else {
        this.searchFilterArray = _.filter(
          this.tempTemplate,
          item => {
            return (item && item.templateName ? (item.templateName.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.templateSenderKey ? (item.templateSenderKey.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.templateSenderName ? (item.templateSenderName.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.templateType ? (item.templateType.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.templateUserType ? (item.templateUserType.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.templatePageType ? (item.templatePageType.toLowerCase().search(value.toLowerCase()) >= 0) : '') ||
            (item && item.status ? (item.status.toLowerCase().search(value.toLowerCase()) >= 0) : '')
          }
        )
        this.total = this.searchFilterArray.length
      }
    },
    addTemplate: function () {
      this.$router.push({ name: 'createTemplates' })
    },
    showPopup: function (msg) {
      this.templateMsg = window.atob(msg)
      this.PreviewPopup = true
    },
    getTemplate: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/communication/template?page=1`)
        this.data = response.data.rows

        this.tempTemplate = response.data.rows
        this.tempTemplate = _.map(this.tempTemplate, a => {
          a.status = a.isActive ? 'Active' : 'Deactive'
          return a
        })

        this.searchFilterArray = this.tempTemplate
        this.total = response.data.count
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.enableUniformModal = false
        return this.errMsg(`Error While fetching Template : ${errorMessage}`)
      }
    },
    getClass: function (isActive) {
      return !isActive ? 'tag is-danger' : 'tag is-success'
    },
    deleteTemplate: async function (templateId) {
      let ref = this

      this.$buefy.dialog.confirm({
        title: 'Delete Template',
        message: 'Do you really want to <b>delete</b> this record?',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: async () => {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.delete(`${constants.API_URL}/api/communication/template/${templateId}`)
            ref.loadingComponent.close()
            await ref.getTemplate()
            return this.okMsg(`Deactivated Template Successfully`)
          } catch (e) {
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            ref.loadingComponent.close()
            return this.errMsg(errorMessage)
          }
        }
      })
    },
    restoreTemplate: async function (templateId) {
      let ref = this
      this.$buefy.dialog.confirm({
        title: 'Restore Template',
        confirmText: 'Yes',
        cancelText: 'No',
        type: 'is-warning',
        hasIcon: true,
        message: 'Do you want to restore Template?',
        onConfirm: async function () {
          try {
            ref.loadingComponent = ref.$buefy.loading.open()
            await http.put(`${constants.API_URL}/api/communication/template/${templateId}/restore`)
            ref.loadingComponent.close()
            await ref.getTemplate()
            return this.okMsg(`Template restored successfully!`)
          } catch (e) {
            console.log(e)
            ref.loadingComponent.close()
            const errorMessage = (e && e.response && e.response.data.message) || e.message
            return this.errMsg(`Error While restore of Template : ${errorMessage}`)
          }
        }
      })
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
